<template>
  <section :class="{
    'style-round': cornerStyle === 'round',
    'style-square': cornerStyle === 'square',
    'align-left': formattedWEBStoryLinkImage,
    fontLoaded
  }">
    <button :style="{ fontFamily: fontFamilyCSS }" v-on:click="submit($event)">
      <div v-if="formattedWEBStoryLinkImage" class="swimg">
        <img :src="formattedWEBStoryLinkImage" :alt="WEBStoryLinkText">
      </div>
      <span>{{WEBStoryLinkText}}</span>
    </button>
  </section>
</template>

<script>
import { mapState, mapGetters } from 'vuex';

export default {
  name: 'StoryButton',
  props: {
  },
  computed: {
    ...mapState('poll', [
      'cornerStyle',
      'fontLoaded',
      'WEBStoryLinkText'
    ]),
    ...mapGetters('poll', [
      'fontFamilyCSS',
      'formattedWEBStoryLinkImage',
      'formattedWEBStoryLinkURL'
    ])
  },
  methods: {
    submit(event) {
      event.preventDefault();
      window.location.href = this.formattedWEBStoryLinkURL;
    }
  }
}
</script>

<style scoped lang="scss">
section {
  flex: 0 0 auto;
  width: 100%;
  margin: 0 !important;
  position: relative;
  z-index: 1;
}

button {
  font-size: 0;
  line-height: 1em;
  padding: 16px 20px 14px;
  text-align: center;
  border-radius: var(--button-radius);
  display: block;
  width: 100%;
  background-color: transparent;
  color: var(--button-color);
  cursor: pointer;
  opacity: 0;
  border: 1px solid var(--answer-color);
  outline: none;
  border: 1px solid var(--answer-color);

  &:disabled {
    cursor: not-allowed;
  }

  &:hover {
    .swimg {
      transform: scale(1.1);
      transition-delay: 0s;
    }
  }

  span {
    font-size: var(--answer-fontsize);
    vertical-align: middle;
    line-height: var(--answer-fontsize);
  }

  .swimg {
    width: var(--answer-img-width);
    height: var(--answer-img-height);
    border-radius: var(--answer-img-radius);
    overflow: hidden;
    margin: -9px;
    margin-left: -10px;
    margin-right: 14px;
    display: inline-block;
    vertical-align: middle;
    flex: 0 0 auto;
    transition: all 2500ms cubic-bezier(0.22, 1, 0.36, 1);
    transform: scale(1);

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
}

.style-square {

  button {
    border-radius: 4px;
  }
}

.align-left {

  button {
    text-align: left;
  }
}

.fontLoaded {

  button {
    opacity: 1;

    &:disabled {
      opacity: 0.5;
    }
  }
}
</style>
